import { Box, Button, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

const NotFoundComponent: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				pt: 10,
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				alignContent: "center",
			}}
		>
			<Typography variant="h1">404</Typography>
			<Typography>{t("error.404.body")}</Typography>
			<div>
				<Link to="/">
					<Button>{t("error.404.btnGoHome")}</Button>
				</Link>
			</div>
		</Box>
	);
};

export default NotFoundComponent;
